import { render, staticRenderFns } from "./ComputersErased.vue?vue&type=template&id=598b574b&"
import script from "./ComputersErased.vue?vue&type=script&lang=js&"
export * from "./ComputersErased.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports